//
//
//
//
//
//
//

import PwrConfirm from '../../../../../common/modal/PwrConfirm';

export default {
  name: 'ConfirmSkip',
  components: { PwrConfirm },
  methods: {
    show() {
      this.$refs.modal.show();
    },
  },
};
